module.exports = "https://health.dajiuxing.com.cn/img/assets/img/write_off_img.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2Fimg%2Fwrite_off_img.png
// module id = yjQz
// module chunks = 93